import { Permission, userHasAllPermissions, userHasAnyPermission, userHasPermission } from "./permissions";
import { getProductData, isKITProduct, type ProductData } from "../models/ProductData";
import { isProductPMA } from "../feature/ProductDescriptor/v1/productDescriptorUtils";
import { userIsCustomer, userIsLoggedIn } from "./roles";
import { hasSuccessor } from "~/utils/productUtils";
import type { ProductDescriptor } from "~/feature/ProductDescriptor/v1/types";

interface CanSeeListPriceProps {
  product: ProductDescriptor;
  hasSurcharge?: boolean;
  isSpecialPrice?: boolean;
}

export function canSeeListPrice({ product, isSpecialPrice, hasSurcharge }: CanSeeListPriceProps) {
  return (
    userHasPermission(Permission.SEE_LIST_PRICE) &&
    product.base.quantityVisible &&
    !isKITProduct(product.base) &&
    !isProductPMA(product) &&
    !isSpecialPrice &&
    !hasSurcharge
  );
}

export function canSeeWishlistButton() {
  return !userIsLoggedIn() || userHasPermission(Permission.ADD_TO_WISHLIST);
}

export function canSeeAddToCartButton(strict = false) {
  if (userIsCustomer()) {
    return (
      userHasAllPermissions(Permission.PRICE, Permission.AVAILABILITY) &&
      (strict
        ? userHasPermission(Permission.ADD_TO_CART)
        : userHasAnyPermission(Permission.ADD_TO_CART, Permission.ADD_TO_QUOTE))
    );
  } else if (userHasPermission(Permission.ADD_TO_CART)) {
    return true;
  }
}

export function canSeeNewProductVersion(product: ProductData | ProductDescriptor) {
  return userIsLoggedIn() && hasSuccessor(getProductData(product));
}

export function isMarketingConsentEnabled() {
  return window.SCHA.toggles.marketingConsentEnabled;
}

export function isLineLevelCustomerOrderNumberEnabled() {
  return window.SCHA.toggles.customerOrderNumberAtLineLevel;
}

export function isTruncateDesignationsEnabled() {
  return true;
}

export function isInvoiceNumberEnabled() {
  return window.SCHA.config.downloadInvoice;
}

export function isCADInquiryEnabled() {
  return false;
}

export function isMultiAccountOrderSearchEnabled() {
  return window.SCHA.toggles.multipleAccountSearchEnabled;
}

export function isPartialDeliveriesEnabled() {
  return true;
}

/**
 * When enabled, surcharge is already included in price coming from SAP (old way).
 * When disabled, surcharge will be added by the FE (new way).
 */
export function isSurchargeIncludedInPriceValue() {
  return window.SCHA.config.isSurchargeIncludedInPriceValue ?? false;
}

export function isNewNavigationEnabled() {
  return window.SCHA.feature.showNewNavigation ?? false;
}

export function showDateAsCalendarWeek() {
  return window.SCHA.feature.showDateAsCalendarWeek ?? false;
}

export function isBEPriceCalculationEnabled() {
  return window.SCHA.feature.bePriceCalculation ?? false;
}
